export const STRATEGY_TAGS = [
  'AI-Powered Strategy',
  'Crypto Only',
  'Equities Only',
  'Mixed Asset',
  'Prediction Markets',
  'Quant Strategy',
  'Thesis Driven',
];

export const RISK_LEVELS = ['low', 'medium', 'high'];

export const ASSET_CLASSES = ['equities', 'crypto', 'prediction', 'mixed'];

export const ASSET_TYPES = ['stock', 'etf', 'crypto', 'prediction'];

export const STRATEGY_TYPES = ["automated", "manual"];
export const BENCHMARKS = ["none", "sp500", "btc", "eth"];
export const TRADE_DIRECTIONS = ["buy", "sell", "short", "cover"];
